export default __webpack_public_path__ + "static/media/validate.a0f2b59d.png";